import React from "react";

export const DsokCustomerDetailDataContext = React.createContext({
  customerUrl: null,
  data: null,
  loading: true,
  error: null,
  refetch: () => {},
  isDirty: false,
  setDirty: () => {},
  resetDirty: () => {},
  /** Snapshot of dsokSettings from last load/successful update; used as base for section-scoped update */
  originalDsokSettings: null,
  setOriginalDsokSettings: () => {},
  registerSectionUpdatePayload: () => {},
  unregisterSectionUpdatePayload: () => {},
  getSectionUpdatePayload: () => null,
});
